import { Fragment, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { LazyLoadImage } from "react-lazy-load-image-component";
// import { MobileAppDevelopmentData } from "../../common";
import { Card, CardBody, CardHeader, CardTitle, Col, Container, Row } from "reactstrap";
// core components
import Header from "../../components/header/header";
import Footer from "../../components/footer/footer";
import AboutUsBanner from "../../components/AboutUs/AboutUsBanner";
import CustomerReviews from "../../components/CustomerReviews/CustomerReviews";
import ContactUsComponent from "../../components/ContactUsComponent/ContactUsComponent";
import StepCard from "./StepCard";
import FrequentlyAskedQuestions from "../../components/FrequentlyAskedQuestions/FrequentlyAskedQuestions";
import { getIPGeoLocation } from "../../common/GeneralUtils";
// import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import axios from "axios";
import * as Icons from '../../common/icons/mobileAppDevelopmentIcons';
import Toasts from "../../components/Toasts/Toasts";
// import Loadable from "../../components/Loadable"

// const Header = Loadable(
//     lazy(() => import('../../components/header/header'))
// )
// const Footer = Loadable(
//     lazy(() => import('../../components/footer/footer'))
// )
// const AboutUsBanner = Loadable(
//     lazy(() => import('../../components/AboutUs/AboutUsBanner'))
// )
// const CustomerReviews = Loadable(
//     lazy(() => import('../../components/CustomerReviews/CustomerReviews'))
// )
// const ContactUsComponent = Loadable(
//     lazy(() => import('../../components/ContactUsComponent/ContactUsComponent'))
// )
// const StepCard = Loadable(
//     lazy(() => import('./StepCard'))
// )
// const FrequentlyAskedQuestions = Loadable(
//     lazy(() => import('../../components/FrequentlyAskedQuestions/FrequentlyAskedQuestions'))
// )


const MobileAppDevelopmentScreen = () => {
    const [toasts, setToasts] = useState(null)
    const [MobileAppDevelopmentData, setData] = useState({});

    const getAllMobileAppDevelopmentData = async () => {
        try {
            const res = await axios.get('/staticDataFiles/mobileAppDevelopmentData.json');
            setData(res.data);
        } catch (err) {
            console.error('Error fetching blogs:', err);
        }
    }

    useEffect(() => {
        getIPGeoLocation();
        getAllMobileAppDevelopmentData();
    }, [])
    return (
        <Fragment>
            <Helmet>
                <title>Modern Mobile App Development Services for Global Clients</title>
                <meta name="description" content="VarahiSoft delivers user-friendly, secure, and scalable mobile apps development service to built and grow your business. Contact us now!" />
                <meta name="keywords" content="mobile app development service" />
                <meta property="og:title" content="Modern Mobile App Development Services for Global Clients" />
            </Helmet>
            <div id="main-wrapper">
                <Header />
                <div className="page-wrapper mobile-app-development-page-wrapper">
                    <div className="container-fluid">
                        <div className="page-content-top">
                            <AboutUsBanner bannerImg={MobileAppDevelopmentData?.bannerImg} data={MobileAppDevelopmentData?.headerData} />
                            <div className="content-tech-page-warper">
                                <Container>
                                    <div className="page-context-text">
                                        <h2>{MobileAppDevelopmentData?.BuildFuture?.title}</h2>
                                        {MobileAppDevelopmentData?.BuildFuture?.textData.map((text, index) => <p key={index}><span>{text?.text}</span> <span className="fw-bold">{text?.bold1}</span> <span>{text?.text1}</span> <span className="fw-bold">{text?.bold2}</span> <span>{text?.text2}</span></p>)}
                                    </div>
                                </Container>
                            </div>
                            <section className="why-mobile-app-development">
                                <Container>
                                    <Row>
                                        <Col lg={6} md={6} className="m-auto text-start">
                                            <div className="img-div-width">
                                                <LazyLoadImage
                                                    alt={'image'}
                                                    className="w-100"
                                                    src={MobileAppDevelopmentData?.WhyMobileAppDevelopment?.pageImg} // use normal <img> attributes as props
                                                />
                                            </div>
                                            {/* <img src={tech?.pageImg} alt="img" /> */}
                                        </Col>
                                        <Col className="tech-page-warper px-5" lg={6} md={6}>
                                            <h3>{MobileAppDevelopmentData?.WhyMobileAppDevelopment?.title}</h3>
                                            <p className="mb-5">{MobileAppDevelopmentData?.WhyMobileAppDevelopment?.paragraph}</p>
                                            <ul>
                                                {MobileAppDevelopmentData?.WhyMobileAppDevelopment?.list.map((text, index) =>
                                                    <li key={index}><span>{text?.text}</span> <span className="bold">{text?.bold}</span> <span>{text?.text1}</span></li>
                                                )}
                                            </ul>
                                            <p className="mt-5">{MobileAppDevelopmentData?.WhyMobileAppDevelopment?.paragraph1}</p>
                                        </Col>
                                    </Row>
                                </Container>
                            </section>
                            <section className="core-mobile-app-section">
                                <Container>
                                    <h3>{MobileAppDevelopmentData?.CoreServices?.title}</h3>
                                    <h4>{MobileAppDevelopmentData?.CoreServices?.subtitle}</h4>
                                    <div className="core-mobile-app-card">
                                        <Row className="m-0">
                                            {MobileAppDevelopmentData?.CoreServices?.listData?.map((cardItem, index) => {
                                                const Icon = Icons[cardItem?.icon] || null;
                                                return <Col key={index} md={4} lg={4} sm={1}>
                                                    <Card className="app-card">
                                                        <CardBody>
                                                            <p>
                                                                {Icon && <Icon />}
                                                            </p>
                                                            <h5 className="card-title-div">{cardItem?.title}</h5>
                                                            <p><span>{cardItem?.text}</span>{cardItem?.bold && <span>{cardItem?.bold}</span>}{cardItem?.text1 && <span>{cardItem?.text1}</span>}</p>
                                                        </CardBody>
                                                    </Card>
                                                </Col>
                                            })}
                                        </Row>

                                    </div>
                                </Container>

                            </section>
                            <section className="core-mobile-app-process" >
                                <Container>
                                    <h3>{MobileAppDevelopmentData?.MobileAppDevelopmentProcess?.title}</h3>
                                    <h4>{MobileAppDevelopmentData?.MobileAppDevelopmentProcess?.subtitle}</h4>
                                    <div className="core-mobile-app-card pt-5">
                                        <Row>
                                            <Col lg={6} md={6} xs={12}>
                                                <div className="max-w-3xl mx-auto py-10">
                                                    {MobileAppDevelopmentData?.MobileAppDevelopmentProcess?.steps?.map((step, index) => (
                                                        <StepCard key={step.id} {...step} isLast={index === MobileAppDevelopmentData?.MobileAppDevelopmentProcess?.steps.length - 1} />
                                                    ))}
                                                </div>
                                            </Col>
                                            <Col lg={6} md={6} xs={12} className="d-flex align-items-center">
                                                <div className="img-div-width">
                                                    <LazyLoadImage
                                                        alt={'image'}
                                                        className="w-100"
                                                        src={MobileAppDevelopmentData?.MobileAppDevelopmentProcess?.pageImg} // use normal <img> attributes as props
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </Container>

                            </section>
                            <section className="core-mobile-app-benefits">
                                <Container>
                                    <h3>{MobileAppDevelopmentData?.Benefits?.title}</h3>
                                    <h4>{MobileAppDevelopmentData?.Benefits?.subtitle}</h4>
                                    <div className="core-mobile-app-card">
                                        <div className="d-flex gap-3">
                                            {MobileAppDevelopmentData?.Benefits?.listData.map((list, index) => {
                                                return (
                                                    <Card key={index} className="app-card">
                                                        <CardHeader className="d-flex align-items-center">
                                                            <CardTitle className="m-auto">{list?.title}</CardTitle>
                                                        </CardHeader>
                                                        <CardBody>
                                                            {list?.paragraph}
                                                        </CardBody>
                                                    </Card>
                                                )
                                            })}
                                        </div>
                                    </div>
                                </Container>
                            </section>
                            <section className="core-mobile-app-invest-div" >
                                <Container>
                                    <div className="core-mobile-app-card">
                                        <Row>
                                            <Col lg={6} md={6} xs={12} className="d-flex align-items-center">
                                                <div className="m-auto">
                                                    <LazyLoadImage
                                                        alt={'image'}
                                                        className="w-100"
                                                        src={MobileAppDevelopmentData?.InvestMobileApps?.pageImg} // use normal <img> attributes as props
                                                    />
                                                </div>
                                            </Col>
                                            <Col lg={6} md={6} xs={12} className="px-4">
                                                <h3>{MobileAppDevelopmentData?.InvestMobileApps?.title}</h3>
                                                <div className="invest-list">
                                                    <ul>
                                                        {MobileAppDevelopmentData?.InvestMobileApps?.listData.map((invest, index) => {
                                                            return (<li key={index}><p>{invest?.text}</p></li>)
                                                        })
                                                        }
                                                    </ul>
                                                </div>
                                                <h4 className="pe-4">{MobileAppDevelopmentData?.InvestMobileApps?.subtitle}</h4>
                                            </Col>
                                        </Row>
                                    </div>
                                </Container>
                            </section>
                            <section className='core-mobile-app-build-somethingAmazingTogether-div' style={{ backgroundImage: `url(${MobileAppDevelopmentData?.BuildSomethingAmazingTogether?.bgImg})` }}>
                                <div className="client-count text-white">
                                    <Container>
                                        <Row className='Fre8-Pro'>
                                            <Col lg="8" md='7' className='ps-0 m-auto d-flex justify-content-center align-items-center gap-5'>
                                                <div className="display-7 align-self-center">
                                                    <h3 className='mb-3'>{MobileAppDevelopmentData?.BuildSomethingAmazingTogether?.title}</h3>
                                                    <p>{MobileAppDevelopmentData?.BuildSomethingAmazingTogether?.paragraph?.text}<Link className='text-decoration-none text-white' to={window?.location?.origin}>{MobileAppDevelopmentData?.BuildSomethingAmazingTogether?.paragraph?.link}</Link> {MobileAppDevelopmentData?.BuildSomethingAmazingTogether?.paragraph?.text1}</p>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Container>
                                </div>
                            </section>
                            <CustomerReviews />
                            <div className="home-contact-page">
                                <ContactUsComponent setToasts={setToasts} />
                            </div>
                            <FrequentlyAskedQuestions faqData={MobileAppDevelopmentData?.FrequentlyAskedQuestionsData} />
                        </div>
                    </div>
                </div>
                <Footer />
                {toasts && <Toasts toastsList={toasts} />}
            </div>
        </Fragment>
    );
}

MobileAppDevelopmentScreen.propTypes = {
    classes: PropTypes.object
};

export default MobileAppDevelopmentScreen;
